import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=355f2612&"
import script from "./EditForm.vue?vue&type=script&lang=js&"
export * from "./EditForm.vue?vue&type=script&lang=js&"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=355f2612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports